import * as React from 'react';
import { SVGProps } from 'react';

const IconOilBarrelSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M3 1a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2H3Z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3 9a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2V4H3v5Zm3-1a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
    />
  </svg>
);
export default IconOilBarrelSizeXs;
